// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Spice from "@greenlabs/ppx-spice/src/rescript/Spice.mjs";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.mjs";
import * as React from "@sentry/react";
import * as RescriptRelay from "rescript-relay/src/RescriptRelay.mjs";
import * as RelayRuntime from "relay-runtime";
import * as Caml_exceptions from "rescript/lib/es6/caml_exceptions.js";
import * as SubscriptionsTransportWs from "@cardoc/frontend-common/src/bindings/SubscriptionsTransportWs.mjs";
import * as Env$CardocFrontendPartners from "./constants/Env.mjs";
import * as ReactNativeWebview$CardocFrontendPartners from "./utils/ReactNativeWebview.mjs";

var Graphql_error = /* @__PURE__ */Caml_exceptions.create("RelayEnv-CardocFrontendPartners.Graphql_error");

function error_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([[
                    "message",
                    false,
                    Spice.stringToJson(v.message)
                  ]]));
}

function error_decode(v) {
  if (!Array.isArray(v) && (v === null || typeof v !== "object") && typeof v !== "number" && typeof v !== "string" && typeof v !== "boolean") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (!(typeof v === "object" && !Array.isArray(v))) {
    return Spice.error(undefined, "Not an object", v);
  }
  var message = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(v, "message"), null));
  if (message.TAG === "Ok") {
    return {
            TAG: "Ok",
            _0: {
              message: message._0
            }
          };
  }
  var e = message._0;
  return {
          TAG: "Error",
          _0: {
            path: ".message" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function response_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "data",
                    false,
                    (function (extra) {
                          return Spice.optionToJson((function (v) {
                                        return v;
                                      }), extra);
                        })(v.data)
                  ],
                  [
                    "errors",
                    false,
                    (function (extra) {
                          return Spice.optionToJson((function (extra) {
                                        return Spice.arrayToJson(error_encode, extra);
                                      }), extra);
                        })(v.errors)
                  ]
                ]));
}

function response_decode(v) {
  if (!Array.isArray(v) && (v === null || typeof v !== "object") && typeof v !== "number" && typeof v !== "string" && typeof v !== "boolean") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (!(typeof v === "object" && !Array.isArray(v))) {
    return Spice.error(undefined, "Not an object", v);
  }
  var data = (function (extra) {
        return Spice.optionFromJson((function (v) {
                      return {
                              TAG: "Ok",
                              _0: v
                            };
                    }), extra);
      })(Belt_Option.getWithDefault(Js_dict.get(v, "data"), null));
  if (data.TAG === "Ok") {
    var errors = (function (extra) {
          return Spice.optionFromJson((function (extra) {
                        return Spice.arrayFromJson(error_decode, extra);
                      }), extra);
        })(Belt_Option.getWithDefault(Js_dict.get(v, "errors"), null));
    if (errors.TAG === "Ok") {
      return {
              TAG: "Ok",
              _0: {
                data: data._0,
                errors: errors._0
              }
            };
    }
    var e = errors._0;
    return {
            TAG: "Error",
            _0: {
              path: ".errors" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = data._0;
  return {
          TAG: "Error",
          _0: {
            path: ".data" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function parse(json) {
  var response = response_decode(json);
  if (response.TAG === "Ok") {
    return response._0;
  }
  
}

function isUnauthorized(param) {
  return Core__Option.isSome(Belt_Array.getBy(Core__Option.getOr(param.errors, []), (function (param) {
                    return param.message === "Unauthorized";
                  })));
}

function logout() {
  localStorage.removeItem("accessToken");
  ReactNativeWebview$CardocFrontendPartners.SendMessageEvent.sendPostMessage({
        kind: "Logout"
      });
  var url = new URL(window.location.href);
  url.pathname = "login";
  url.searchParams.set("redirectUrl", window.location.pathname);
  window.location.href = url.href;
}

var RelayResponse = {
  response_encode: response_encode,
  response_decode: response_decode,
  error_encode: error_encode,
  error_decode: error_decode,
  parse: parse,
  isUnauthorized: isUnauthorized,
  logout: logout
};

async function fetchQuery(operation, variables, _cacheConfig, _uploadables) {
  try {
    var accessToken = Core__Option.getOr(Caml_option.null_to_opt(localStorage.getItem("accessToken")), "");
    React.addBreadcrumb({
          type: "info",
          level: "info",
          category: "relay",
          data: {
            query: operation.text,
            variables: variables
          }
        });
    var res = await fetch(Env$CardocFrontendPartners.apiUrl + "/graphql", {
          method: "POST",
          body: Caml_option.some(Belt_Option.getExn(JSON.stringify({
                        query: operation.text,
                        variables: variables
                      }))),
          headers: Caml_option.some(new Headers({
                    "content-type": "application/json",
                    accept: "application/json",
                    Authorization: "Bearer " + accessToken,
                    "x-graphql-client-name": "partners-web-" + Env$CardocFrontendPartners.mode,
                    "x-graphql-client-version": "partners-20241104"
                  }))
        });
    if (res.ok) {
      var json = await res.json();
      if (Core__Option.mapOr(parse(json), false, isUnauthorized)) {
        var match = window.location.pathname;
        switch (match) {
          case "/" :
          case "/login" :
              break;
          default:
            logout();
        }
      }
      return json;
    }
    throw {
          RE_EXN_ID: Graphql_error,
          _1: "Request failed: " + res.statusText,
          Error: new Error()
        };
  }
  catch (_err){
    throw {
          RE_EXN_ID: Graphql_error,
          _1: "Request failed",
          Error: new Error()
        };
  }
}

var subscriptionClient = SubscriptionsTransportWs.createSubscriptionClient(Env$CardocFrontendPartners.websocketUrl + "/graphql", {
      reconnect: true,
      connectionParams: {
        authToken: Core__Option.getOr(Caml_option.null_to_opt(localStorage.getItem("accessToken")), "")
      }
    });

function subscriptionFunction(config, variables, _cacheConfig) {
  var query = config.text;
  var subscriptionQuery_operationName = config.name;
  var subscriptionQuery = {
    query: query,
    variables: variables,
    operationName: subscriptionQuery_operationName
  };
  return RelayRuntime.Observable.create(function (sink) {
              var observable = subscriptionClient.request(subscriptionQuery);
              return observable.subscribe(sink);
            });
}

var network = RelayRuntime.Network.create(fetchQuery, subscriptionFunction);

var environment = RescriptRelay.Environment.make(network, RescriptRelay.Store.make(new RelayRuntime.RecordSource(), 10, undefined), undefined, undefined, undefined, undefined, undefined);

export {
  Graphql_error ,
  RelayResponse ,
  fetchQuery ,
  subscriptionClient ,
  subscriptionFunction ,
  network ,
  environment ,
}
/* subscriptionClient Not a pure module */
